import { useFormContext } from "react-hook-form";

import { ImageTile, TextInputField } from "@/components/kit";
import { SubCategoryFormData } from "@/schemas/subcategory-form.schema.";

interface SubCategoryFormProps {
  disabledFields?: Array<keyof SubCategoryFormData>;
}

export const SubCategoryForm = ({ disabledFields }: SubCategoryFormProps) => {
  const form = useFormContext<SubCategoryFormData>();
  const image = form.watch("image");
  const off = (field: keyof SubCategoryFormData) =>
    disabledFields?.includes(field);

  return (
    <div className="flex flex-col gap-4">
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
        <TextInputField<SubCategoryFormData>
          isDisabled={off("name")}
          label="Subcategory Name"
          name="name"
          placeholder="Flavoured milk"
        />
        <TextInputField<SubCategoryFormData>
          dir="rtl"
          isDisabled={off("nameAr")}
          label="Subcategory Name (Arabic)"
          name="nameAr"
          placeholder="حليب بنكهات"
        />
      </div>
      <TextInputField<SubCategoryFormData>
        isMono
        description="Auto-generated from name. Can only contain lowercase letters, numbers, and hyphens."
        isDisabled={off("id")}
        label="Subcategory ID"
        name="id"
        placeholder="subcategory-id"
      />
      <div className="flex items-start gap-3">
        <div className="min-w-0 flex-1">
          <TextInputField<SubCategoryFormData>
            isDisabled={off("image")}
            label="Image URL"
            name="image"
            placeholder="https://…"
          />
        </div>
        <div className="mt-[22px]">
          <ImageTile size="md" src={image} />
        </div>
      </div>
    </div>
  );
};
